// extracted by mini-css-extract-plugin
export var breadCrumb = "blog-article-module--breadCrumb--d9b97";
export var buttonStyle = "blog-article-module--buttonStyle--2071f";
export var card = "blog-article-module--card--7c30a";
export var closedSources = "blog-article-module--closedSources--9dc0e";
export var contentStyle = "blog-article-module--contentStyle--fb1ed";
export var expandSectionButton = "blog-article-module--expandSectionButton--056a1";
export var expanded = "blog-article-module--expanded--5977e";
export var genericContainer = "blog-article-module--genericContainer--a77b9";
export var gridContainer = "blog-article-module--gridContainer--5d18f";
export var gridContent = "blog-article-module--gridContent--69d8f";
export var gridStaticContainer = "blog-article-module--gridStaticContainer--be3ba";
export var headingTitle = "blog-article-module--headingTitle--c54e3";
export var indexSectionDesktop = "blog-article-module--indexSectionDesktop--3c8ba";
export var indexSectionMobile = "blog-article-module--indexSectionMobile--6b95d";
export var lastUpdated = "blog-article-module--lastUpdated--db38b";
export var mainContent = "blog-article-module--mainContent--4be72";
export var mainImage = "blog-article-module--mainImage--df963";
export var openedSources = "blog-article-module--openedSources--f32ec";
export var recommendations = "blog-article-module--recommendations--e916d";
export var relatedItems = "blog-article-module--relatedItems--4fff3";
export var relatedOnTablet = "blog-article-module--relatedOnTablet--4fa20";
export var relatedSection = "blog-article-module--relatedSection--b4cde";
export var relatedTitle = "blog-article-module--relatedTitle--d608e";
export var rightBroadstreetAd = "blog-article-module--rightBroadstreetAd--c2c12";
export var sorcesContent = "blog-article-module--sorcesContent--5a86b";
export var sourceButton = "blog-article-module--sourceButton--54a9f";
export var sourcesTitle = "blog-article-module--sourcesTitle--3a0bc";
export var sourcesTitleIcon = "blog-article-module--sourcesTitleIcon--7c606";
export var sponsorCard = "blog-article-module--sponsorCard--a8082";
export var subscribeContent = "blog-article-module--subscribeContent--558db";
export var subscribeForm = "blog-article-module--subscribeForm--c5e03";
export var subscribeImageContainer = "blog-article-module--subscribeImageContainer--018d3";
export var subscribeSection = "blog-article-module--subscribeSection--3ffee";
export var subscribeTitle = "blog-article-module--subscribeTitle--36855";